import Gravatar from "./Gravatar";

export default Gravatar;
